import { render } from "./CreateNewTopic.vue?vue&type=template&id=0754ba0e&scoped=true"
import script from "./CreateNewTopic.vue?vue&type=script&lang=js"
export * from "./CreateNewTopic.vue?vue&type=script&lang=js"

import "./CreateNewTopic.vue?vue&type=style&index=0&id=0754ba0e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0754ba0e"]])

export default __exports__